module.exports = __webpack_public_path__ + "img/step7.42b81e9c.png";